<template>
  <div class="body-wrapper">
    <app-header />
    <div class="page-content">
      <div class="page-content-box">
        <div class="container">
          <div class="message-box">
            <p>Dzień dobry,</p>
            <p>Przepraszamy ale od dnia 01.12.2024 doładowania na stronie <strong>https://doladuj-enea.autopay.pl</strong> nie są już dostępne.</p>
            <p>W razie pytań skontaktuj się ze swoim zakładem energetycznym.</p>
            <p>
              Pozdrawiamy,<br>
              Zespół Autopay
            </p>
          </div>
        </div>
      </div>
    </div>
    <app-footer />
  </div>
</template>

<script>
import AppHeader from '@/enea/components/AppHeader'
import AppFooter from '@/enea/components/AppFooter'

export default {
  components: {
    AppFooter,
    AppHeader
  }
}
</script>

<style src="./assets/scss/app.scss" lang="scss"></style>
<style lang="scss">
.message-box {
  padding: 50px 20px;
  @media (min-width: 768px) {
    padding: 100px;
  }
}
</style>
